import * as React from "react";
import { ProviderProgramItem } from "../../interfaces/providerprogram";
import { Link } from "react-router";

interface IProgramProps {
    program: ProviderProgramItem;
}

const Program = ({ program }: IProgramProps) => {
    let description: React.JSX.Element | null = null;
    if (program.descriptionHtml) {
        const getHtml = function () {
            return { __html: program.descriptionHtml! };
        };

        description = <p className="card-text" dangerouslySetInnerHTML={getHtml()}></p>
    }

    const programLink = "/program/" + program.programCode;

    return (
        <div className="card my-3" >
            <div className="card-body">
                <h5 className="card-title">{program.programName}</h5>
                {description}
                <Link to={programLink} className="btn btn-primary btn-sm">Register</Link>
            </div>
        </div>
    );
};

export default Program;
